import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";

const useStyles = createUseStyles((theme) => ({
	root: {
		textAlign: "center",
	},
	rootAntiFilter: {
		// margin: "10px"
	},
	purpleButton: {
		width: "250px",
		height: "56px",
		fontFamily: theme.fonts.medium,
		color: theme.palette.colors.white,
		textTransform: "uppercase",
		fontSize: "16px",
		lineHeight: "1.22",
		letterSpacing: "1px",
		cursor: "pointer",
		backgroundColor: theme.palette.colors.purplishBlue,
		borderRadius: "10px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		textAlign: "center",
		userSelect: "none",
		"& a": {
			color: theme.palette.colors.white,
		},
	},
	purpleButtonAntiFilter: {
		width: "140px",
		height: "40px",
		margin: "15px auto 20px",
		fontSize: "12px",
		lineHeight: "1.6",
	},
	defaultCursor: {
		cursor: "default",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		purpleButton: {
			width: "165px",
			fontSize: "14px",
		},
		purpleButtonAntiFilter: {
			width: "140px",
			fontSize: "12px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		purpleButton: {
			width: "140px",
			fontSize: "12px",
			margin: "0 auto",
			lineHeight: "1.46",
		},
		purpleButtonAntiFilter: {
			margin: "15px auto 20px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			display: "flex",
			width: "100%",
		},
		purpleButton: {
			width: "100%",
			height: "52px",
			fontSize: "12px",
			borderRadius: "0 0 10px 10px",
			order: "3",
		},
		purpleButtonAntiFilter: {
			margin: "15px auto 0",
		},
	},
}));

const MobileConnectButton = ({
	texts,
	connectURL,
	alt_text,
	textInDB,
	defaultCursor,
	onClick,
	antifilter,
	url_name,
}) => {
	const classes = useStyles();

	let sponsored = url_name === "mts" || url_name === "tinkoff";

	const buttonText = alt_text ? texts.CONNECT_OFFICIAL : null;

	const buttonInner = textInDB ? (
		<div>{textInDB}</div>
	) : (
		<div>
			<div>{texts.connect}</div>
			{buttonText && <div>{buttonText}</div>}
		</div>
	);

	let buttonComponent = (
		<div
			className={classNames(classes.purpleButton, {
				[classes.defaultCursor]: defaultCursor,
				[classes.purpleButtonAntiFilter]: antifilter,
			})}
			onClick={onClick}
		>
			{buttonInner}
		</div>
	);

	if (connectURL) {
		buttonComponent = (
			<a
				className={classNames(classes.purpleButton, {
					[classes.defaultCursor]: defaultCursor,
					[classes.purpleButtonAntiFilter]: antifilter,
				})}
				href={connectURL}
				target="_blank"
				onClick={onClick}
				rel={sponsored && "sponsored"}
			>
				{buttonInner}
			</a>
		);
	}

	return (
		<div
			className={classNames(classes.root, {
				[classes.rootAntiFilter]: antifilter,
			})}
		>
			{buttonComponent}
		</div>
	);
};

export default MobileConnectButton;
